import React from 'react';

import { useTranslation } from 'react-i18next';

import { Button } from '../../Sections/Profile/Buttons';

import {
    type DrawerFooterProps,
    type DrawerHeaderProps,
    type DrawerMainProps,
    type DrawerSectionProps,
} from './Sections.types';

import { StyledFooter, StyledHeader, StyledMain, StyledSection } from './Sections.style';

export function Header({ children, sticky = false, onClose }: DrawerHeaderProps) {
    const [translate] = useTranslation('common');

    return (
        <StyledHeader $sticky={sticky}>
            <StyledSection>
                {children}
                <Button color="secondary" variant="solid" onClick={onClose}>
                    {translate('close')}
                </Button>
            </StyledSection>
        </StyledHeader>
    );
}

export function Footer({ children, sticky = false }: DrawerFooterProps) {
    return (
        <StyledFooter $sticky={sticky}>
            <StyledSection>{children}</StyledSection>
        </StyledFooter>
    );
}

export function Main({ children, divided = false }: DrawerMainProps) {
    return <StyledMain $divided={divided}>{children}</StyledMain>;
}

function Section({ children }: DrawerSectionProps) {
    return <StyledSection>{children}</StyledSection>;
}

Main.Section = Section;
